<template lang="pug">
  .type-cursor(ref="cursor" v-show="getCursor !== 3 && getCursor" :class="cursorClass")
    img(:src="currentCursorImage")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: "FontSlider",

  data() {
    return {
      cursorImages: [
        '/static/cursor/flag.svg',
        '/static/cursor/rect.svg',
        '',
        '/static/cursor/circle.svg',
        '/static/cursor/doc.svg',
        '/static/cursor/pen.svg',
        '/static/cursor/hand.svg',
        '/static/cursor/heart.svg',
      ]
    };
  },

  created() {
    window.addEventListener("mousemove", this.handleCursor);
  },

  destroyed() {
    window.removeEventListener("mousemove", this.handleCursor);
  },

  computed: {
    ...mapGetters({
      getCursor: 'getCursor'
    }),

    currentCursorImage() {
      return this.cursorImages[this.getCursor - 1]
    },

    cursorClass() {
      let className = ''
      if (this.getCursor === 6) {
        className = 'pen'
      } else if (this.getCursor === 4) {
        className = 'circle'
      } else if (this.getCursor === 5) {
        className = 'doc'
      } else if (this.getCursor === 8) {
        className = 'heart'
      } else if (this.getCursor === 7) {
        className = 'hand'
      } else if (this.getCursor === 2) {
        className = 'rect'
      } else if (this.getCursor === 1) {
        className = 'flag'
      }
      return className
    }
  },

  methods: {
    handleCursor(e) {
      const style = 'translate3d(' + e.x + 'px, ' + e.y + 'px, 0)'
      this.$refs.cursor.style.transform = style
    }
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-cursor
  width: 17rem
  position: fixed
  top: 0
  left: 0
  margin-left: -8.5rem
  margin-top: -8.5rem
  z-index: 9999999
  pointer-events: none
  display: none
  @media only screen and (min-width: $m)
    display: block
  img
    width: 100%
  &.pen
    height: 16.3rem
    margin-top: -15.8rem
    margin-left: -4.4rem
    img
      height: 100%
      width: auto
  &.circle
    width: 12.3rem
  &.doc
    width: 12rem
    margin-left: 0
    margin-top: 0
  &.flag
    margin: 0
  &.heart
    width: 12rem
  &.hand
    width: 12rem
    margin-top: -1rem
    margin-left: -3rem
  &.rect
    margin-top: 0
    width: 20rem
</style>
